import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose Us</span> TekRevol As Your Telemedicine App
              Development Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              In regards to choosing a telemedicine app development company,
              TekRevol is the optimal candidate because of its ability to
              customize innovative solutions to meet the particular expectations
              of healthcare businesses. Having experience in designing
              telemedicine apps, we match technical skills with knowledge of the
              healthcare industry delivering top-notch service to our clients.
            </p>

            <ul className="mb-3">
              <li>
                <strong>Expertise in Healthcare Technology:</strong> We know the
                intricacies of telemedicine and therefore we can oversee and
                manage HIPAA-compliant exclusively secure solutions.
              </li>
              <li>
                <strong>Customized Solutions:</strong> Our telehealth apps are
                customized to fit exactly the requirements of healthcare
                providers while enhancing the communication process.
              </li>
              <li>
                <strong>User-Centric Design:</strong> Using an intuitive
                approach and considering the functionality impact on patient
                experience and engagement we draw up these apps that are easy to
                use and navigate.
              </li>
              <li>
                <strong>Commitment to Quality:</strong> We follow a rigid
                quality assurance process to ensure that our telemedicine apps
                are of the highest standard of system reliability and security.
              </li>
              <li>
                <strong>Transparent Communication:</strong> From the consumer
                consultation to the delivery of completed work, we are open
                about the process and make room for our clients to be involved.
              </li>
            </ul>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation Today!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/telemedicine/why_choose.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={993}
              height={832}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
